import React from 'react'
import { Input, Row, Switch } from 'antd'
import { useTranslation } from 'next-i18next'
import styles from './DocumentListHeader.module.scss'
import { getFilteredDocuments } from 'src/core/helpers'
import { CustomCol, CustomTitle } from 'src/components'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CheckOutlined, CloseOutlined, SearchOutlined } from '@ant-design/icons'
import { purchaseDocumentsSelector, setDocumentsFiltered, setDocumentsIsAllCollapse } from 'src/features'
import { setDocumentsFilteredText } from 'src/features/admin/slice'

const DocumentListHeader: React.FC<{ quantity: number }> = ({ quantity }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { isAllCollapse, data: bigList, filterText } = useAppSelector(purchaseDocumentsSelector)
  return <Row>
    {/* Title */}
    <CustomCol lg={16}>
      <CustomTitle label={`${t('general.ResultsLength', { length: quantity })}`} type={null} />
    </CustomCol>

    {/* Text */}
    <CustomCol lg={5}>
      <Input
        allowClear
        value={filterText}
        onChange={(e) => {
          dispatch(setDocumentsFilteredText(e.target.value))
          const newList = getFilteredDocuments(e.target.value, bigList)
          dispatch(setDocumentsFiltered(newList))
        }}
        placeholder={t('Withdrawals.Filter')}
        prefix={<SearchOutlined />}
      />
    </CustomCol>

    {/* List View */}
    <CustomCol lg={3}>
      <div className={styles.viewContent}>
        <CustomTitle
          label={isAllCollapse ? t('Expand all') : t('Collapse all')}
          className={styles.label}
        />
        <Switch
          size='small'
          checked={isAllCollapse}
          checkedChildren={<CheckOutlined />}
          unCheckedChildren={<CloseOutlined />}
          onChange={(value) => dispatch(setDocumentsIsAllCollapse(value))}
          className={styles.switch}
        />
      </div>
    </CustomCol>
  </Row>
}

export default DocumentListHeader
